import { SHOW_MODAL, HIDE_MODAL } from '../actions'

const initialState = {
  current: null
}

export default function(state = initialState, action) {
  switch (action.type) {
    case SHOW_MODAL:
      return {
        ...state,
        current: action.payload
      }

    case HIDE_MODAL:
      return {
        ...state,
        current: null
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/modal.js